module.exports = __webpack_public_path__ + "static/media/profile.89d2997f.jpeg";